<template>
  <b-row class="block__profile-info">

    <!-- ENTETE -->
    <div class="mobile">
        <div class="link">
          <button class="bt btn-back"  v-b-toggle.sidebar-2>
            <font-awesome-icon :icon="['far', 'angle-left']"/>
          </button>
          <h3 style="text-align: center">{{general.profileTitle}}</h3>

          <button class="bt bt-blue btn-save" style="position: absolute; right: 20px" @click="sendInfo">
            {{general.formBtSave}}
          </button>
        </div>

      <div class="sep"></div>
    </div>
    <!-- ENTETE -->
      <!-- CONTENT -->
      <div class="scrollable col">
        <h1>{{general.profileTitleInfoPerso}}</h1>

        <b-form-group
          id="input-group-1"
          :label="general.profileFormLabel.lastName"
          label-for="inputs-1"
          description=""
        >
          <b-form-input
            id="inputs-1"
            v-model="settings.lastName"
            type="text"
            required
            :placeholder="general.placeholder.lastName"
          ></b-form-input>
        </b-form-group>


        <b-form-group
          id="input-group-2"
          :label="general.profileFormLabel.firstname"
          label-for="inputs-2"
          description=""
        >
          <b-form-input
            id="inputs-2"
            v-model="settings.name"
            type="text"
            required
            :placeholder="general.placeholder.firstname"
          ></b-form-input>
        </b-form-group>


        <b-form-group
          id="input-group-3"
          :label="general.profileFormLabel.email"
          label-for="inputs-3"
          description=""
        >
          <b-form-input
            id="inputs-3"
            v-model="settings.email"
            type="email"
            required
            :placeholder="general.placeholder.email"
          ></b-form-input>
        </b-form-group>


        <b-form-group
          id="input-group-2"
          :label="general.profileFormLabel.phone"
          label-for="inputs-21"
          description=""
        >
          <b-form-input
            id="inputs-21"
            v-model="settings.phone"
            type="text"
            required
            :placeholder="general.placeholder.phone"
          ></b-form-input>
        </b-form-group>



        <!-- //////////////////////////////////
        ///////////////////////////////////
        //////////////////////////////////// -->
<!--        <h1>{{general.profileTitleInfoAgence}}</h1>


        <b-form-group
          id="input-group-4"
          :label="general.profileFormLabel.codeAgence"
          label-for="inputs-4"
          description=""
          v-if="showAgence"
        >
          <b-form-input
            id="inputs-4"
            v-model="settings.codeAgence"
            type="text"
            required
            :placeholder="general.placeholder.codeAgence"
            disabled
          ></b-form-input>
        </b-form-group>


        <b-form-group
          id="input-group-5"
          :label="general.profileFormLabel.adresse1"
          label-for="inputs-5"
          description=""
        >
          <b-form-input
            id="inputs-5"
            v-model="settings.address"
            type="text"
            required
            :placeholder="general.placeholder.address"
          ></b-form-input>
        </b-form-group>


        <b-form-group
          id="input-group-6"
          :label="general.profileFormLabel.adresse2"
          label-for="inputs-6"
          description=""
        >
          <b-form-input
            id="inputs-6"
            v-model="settings.address2"
            type="text"
            required
            :placeholder="general.placeholder.address2"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-7"
          :label="general.profileFormLabel.city"
          label-for="inputs-7"
          description=""
        >
          <b-form-input
            id="inputs-7"
            v-model="settings.city"
            type="text"
            required
            :placeholder="general.placeholder.city"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-8"
          :label="general.profileFormLabel.postalCode"
          label-for="inputs-8"
          description=""
        >
          <b-form-input
            id="inputs-8"
            v-model="settings.postalCode"
            type="text"
            required
            :placeholder="general.placeholder.postalCode"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-9"
          :label="general.profileFormLabel.region"
          label-for="inputs-9"
          description=""
        >
          <b-form-input
            id="inputs-9"
            v-model="settings.region"
            type="text"
            required
            :placeholder="general.placeholder.region"
          ></b-form-input>
        </b-form-group>-->

        <!-- ////////////////////////////////////////////
        //////////////////////////////////////////////
        /////////////////////////////////////////////// -->
        <h1>{{general.profileTitleInfoMdp}}</h1>

        <b-form-group
          id="input-group-10"
          :label="general.profileFormLabel.mdp"
          label-for="inputs-10"
          description=""
        >
          <b-form-input
            id="inputs-10"
            v-model="form.mdp"
            type="password"
            required
            :placeholder="general.placeholder.mdp"
            :class="{error:error}"
            @change = "verificationMdp()"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-11"
          :label="general.profileFormLabel.mdpConfirm"
          label-for="input-11"
          description=""
        >
          <b-form-input
            id="input-11"
            v-model="form.mdp2"
            type="password"
            required
            :placeholder="general.placeholder.mdp"
            :class="{error:error}"
            @change = "verificationMdp()"
          ></b-form-input>
        </b-form-group>

          <button class="bt bt-blue btn-save" v-if="!isMobile"  @click="sendInfo">
              {{general.formBtSave}}
          </button>  
          
      </div>
      <!-- CONTENT -->

  </b-row>
</template>




<script>
import { mapGetters } from 'vuex'
import Utils from '../../../Utils'
import ApiService from '../../../../services/ApiService'
import ApiAuthenticationService from '../../../../services/ApiAuthenticationService'

export default {
  name:"profileInfo",

    computed: {
      ...mapGetters([
        'getGeneral',
        'getSettings',
          'getIsMobile'
      ])
    },

    data () {
      return {
        show:false,       
        general:'',
        settings:'',
        isMobile:false,
        error:false,
        showAgence:false,
        form:{},    
        infos:{},    
      }
    },
    async created (){
      // GET ALL THE INFORMATIONS / TRANSLATION
      this.isMobile = this.getIsMobile;
      this.general = this.getGeneral;
      this.settings = this.getSettings;
      this.showAgence = ApiAuthenticationService.getCurrentUser().type == 'CONFIG_AGENT' || ApiAuthenticationService.getCurrentUser().type == 'CONFIG_COLLABORATEUR' ? true : false;
    },    
    methods : {

      goBack() {
        this.$router.push({name: "profileHome"});  
      },  
      // CAPITALIZE FIRST LETTER
      capitalizeFirstLetter(string){
        return Utils.capitalizeFirstLetter(string)
      },  

      //SEND INFORMATIONS / PATCH
      async sendInfo(){
        if(this.verificationMdp()){
          this.show = true;       
          let response = await ApiService.getProfilApi().patch(ApiAuthenticationService.getCurrentUser().id,this.settings);
          response.status == '200' ?  this.messageSuccess() : this.messageError();
          ApiAuthenticationService.reloadUser().then(()=>{
            window.location.assign(window.location);
          });
          this.show = false;
        }   
      },
      //CASE OF SUCCESS
      messageSuccess(){
        this.makeToast('success')
        // this.cancel();
      },  
      //CASE OF ERROR
      messageError(){
        this.makeToast('error')
      },  


      //AFFICHAGE DU TOAST
      makeToast(variant = null) {
        if(variant == 'success'){
          this.$bvToast.toast(this.general.profilSuccess, {
            title: this.general.profilToastTitle,
            variant: variant,
            solid: true,
            toaster:'b-toaster-top-center'
          })  
        } else if(variant == 'error'){
          this.$bvToast.toast(this.general.profilError, {
            title: this.general.profilToastTitle,
            variant: variant,
            solid: true,
            toaster:'b-toaster-top-center'
          }) 
        } 
        // else if(variant == 'info'){
        //   this.$bvToast.toast('Le challenge a été mis à jour.', {
        //     title: `Enregistrement challenge`,
        //     variant: 'success',
        //     solid: true,
        //     toaster:'b-toaster-top-center'
        //   }) 
      },

      //CHECK IF EMPTY MDP AND IF MDP == MDP2
      verificationMdp(){
        if(this.form.mdp != '' && this.form.mdp != undefined || this.form.mdp2 != '' && this.form.mdp2 != undefined){
          if(this.form.mdp === this.form.mdp2){
            this.error = false;
            Object.assign(this.settings, {plainPassword: this.form.mdp});
            return true;
          }else{
            this.error = true;
            return false;
          }
        } else {
          if ((this.form.mdp != '' || this.form.mdp != undefined) && (this.form.mdp2 != '' || this.form.mdp2 != undefined)){
            this.error = false;
            return true;
          } else {
            this.error = true;
            return false;
          }
        }
      }
    },
  watch : {
    getIsMobile(){
      this.isMobile = this.getIsMobile;
    }
  }


};
</script>
